import type { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { PageSkeleton } from "./components/states/page-skeleton.tsx";
import { routeTree } from "./routeTree.gen.ts";

/** 路由上下文：页面在 loader 中通过 queryClient 预取数据。 */
export interface RouterContext {
  queryClient: QueryClient;
}

/** 切换页面时，新页面 150 毫秒内未就绪则显示骨架，骨架至少显示 300 毫秒以免闪烁。 */
export const pendingOptions = {
  defaultPendingComponent: PageSkeleton,
  defaultPendingMs: 150,
  defaultPendingMinMs: 300,
};

export function createAppRouter(queryClient: QueryClient) {
  return createRouter({
    routeTree,
    context: { queryClient },
    defaultPreload: "intent",
    scrollRestoration: true,
    ...pendingOptions,
  });
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof createAppRouter>;
  }
}
